import { Typography } from 'antd';
import { ParagraphProps } from 'antd/lib/typography/Paragraph';
import { TitleProps } from 'antd/lib/typography/Title';
import cn from 'classnames';
import { assignTextColorStyle } from '../../../Helper/Text';
import React from 'react';
import KickImage from 'Reuseables/KickImage';
import Styles from './Text.module.scss';
import 'antd/lib/typography/style/css';

export type TTextVariant = 'primary' | 'black' | 'disabled' | 'white';

type TProps = {
  children: React.ReactNode;
  level?: number;
  fontSize?: number | string;
  variant?: TTextVariant;
  color?: string;
} & Omit<TitleProps, 'level'> &
  ParagraphProps;

const { Title, Paragraph } = Typography;

const Text: React.FC<TProps> = ({
  children,
  level,
  ellipsis,
  fontSize,
  variant = 'black',
  color,
  className,
  style = {},
  ...props
}) => {
  assignTextColorStyle(style, variant);

  if (color) {
    Object.assign(style, { color });
  }

  if (level) {
    return (
      <Title
        className={cn(Styles['heading'], `level-${level}`, className)}
        ellipsis={ellipsis}
        {...props}
        style={{ fontSize, ...style }}
      >
        {children}
      </Title>
    );
  } else {
    if (ellipsis) {
      return (
        <Paragraph
          className={cn(`${Styles['paragraph']} ant-paragraph`, className)}
          ellipsis={ellipsis}
          {...props}
        >
          {children}
        </Paragraph>
      );
    } else {
      return (
        <p
          className={cn(`${Styles['paragraph']} ant-paragraph`, className)}
          style={{ ...style }}
          {...props}
        >
          {children}
        </p>
      );
    }
  }
};

export default Text;
